// Empresa parameter constants
export const EMPRESA_PARAMETROS = {
  MODULOS_SELECCIONADOS: 'modulos_seleccionados',
  TAMANO_EMPRESA: 'tamano_empresa',
} as const;

// Other constants can be added here as needed